import Vue from 'vue'
import store from '@/store/store'
import { messages } from '@/i18n/messages'

function lookupMessage(lang, key) {
  const dict = messages[lang] || messages.en
  if (dict[key] !== undefined) return dict[key]
  const other = lang === 'en' ? messages.th : messages.en
  if (other[key] !== undefined) return other[key]
  return key
}

/**
 * Manual i18n: reactive $t(key) via Vuex (no vue-i18n).
 * Lookup reads store.state.locale.lang directly so UI always tracks language changes
 * (avoids Vuex getter-returning-function cache edge cases).
 */
export function installManualI18n() {
  Vue.prototype.$t = function t(key) {
    if (this && this.$store) {
      const lang = this.$store.state.locale.lang
      return lookupMessage(lang, key)
    }
    const lang = store.state.locale.lang
    return lookupMessage(lang, key)
  }

  const lang = store.state.locale.lang
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lang === 'en' ? 'en' : 'th'
  }
}
